<div id="tipovisita" class="padd-1">
  <div *ngIf="checkAbilitato && abilitato">
    <div *ngIf="visitaselezionata && ricercaFatta">
      <div class="container-immagine">
        <div class="overlay"></div>
        <img
          src="{{ visitaselezionata.imgsrc }}"
          class="imgTipoVisita"
          alt=""
        />
        <div
          class="instant promo"
          *ngIf="promoSelezionata && promoSelezionata.codice_required === '0'"
        >
          PROMO
          <span class="material-symbols-outlined instant__icon"> sell </span>
        </div>
      </div>
      <div class="mt-1">
        <app-note-termini
          [note]="cantina.note_base"
          [termini]="cantina.termini_cancellazione"
        ></app-note-termini>
        <div class="head">{{ visitaselezionata.titolo }}</div>
        <app-testo-espandibile
          [text]="visitaselezionata.descrizione"
        ></app-testo-espandibile>
      </div>

      <h3 class="section__subheader mb-0" id="anchor__dropdown">
        {{ "base.prenota_ora" | translate }}
      </h3>

      <div class="info__box__recap__wrapper">
        <button
          class="info__box__recap__section"
          [ngClass]="{ aperto: dropdown_attivo == 1 }"
          (click)="attivaDropdown(1)"
        >
          <div>
            <div class="info__box__recap__label">
              {{ "pagina_acquisto.scelte.label_data" | translate }}
            </div>
            <div class="info__box__recap__value">
              {{ dataMinima }}
            </div>
          </div>
          <span class="material-symbols-outlined dropdown__icon">
            arrow_drop_down
          </span>
        </button>
        <div class="divider" [ngClass]="{ trasparente: dropdown_attivo }"></div>
        <button
          class="info__box__recap__section"
          [ngClass]="{ aperto: dropdown_attivo == 2 }"
          (click)="attivaDropdown(2)"
        >
          <div>
            <div class="info__box__recap__label">
              {{ "pagina_acquisto.scelte.label_posti" | translate }}
            </div>
            <div class="info__box__recap__value">
              {{ stringa_posti }}
            </div>
          </div>
          <span class="material-symbols-outlined dropdown__icon">
            arrow_drop_down
          </span>
        </button>
        <div class="info__box__recap__dropdown" *ngIf="dropdown_attivo">
          <div *ngIf="dropdown_attivo == 1">
            <div class="calendario__flex">
              <div class="calendario__dropdown">
                <mat-calendar
                  [dateFilter]="myFilter"
                  [dateClass]="aggiungiClassiConLingue"
                  [minDate]="oggi"
                  [startAt]="visitaselezionata.data"
                  [selected]="visitaselezionata.data"
                  (selectedChange)="settaOrari($event)"
                >
                </mat-calendar>
              </div>

              <div class="orari__dropdown" *ngIf="showOrari()">
                <div
                  class="orario__item"
                  *ngFor="let visita of dateTipoVistaSelezionata; let i = index"
                  (click)="cambiaVisita(i)"
                  [ngClass]="{
                    selezionato: visitaselezionata.id == visita.id
                  }"
                >
                  {{ visita.data | localizedDate : "shortTime" }}
                </div>
              </div>
            </div>

            <hr class="small" />

            <div class="dropdown__footer">
              <div
                class="dropdown__button btn btn-red"
                (click)="attivaDropdown(2)"
              >
                {{ "pagina_acquisto.scelte.bottoni.conferma" | translate }}
                <span class="material-symbols-outlined dropdown__button__icon">
                  arrow_forward
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="dropdown_attivo == 2">
            <div class="range__wrapper" *ngIf="visitaHasRange()">
              <div
                class="range"
                [ngClass]="
                  range.selezionato
                    ? 'range__selezionato'
                    : 'range__deselezionato'
                "
                *ngFor="let range of visitaselezionata.rangecosti"
              >
                {{ "deluxe.visite.da" | translate }}
                {{ range.min }}
                <span *ngIf="range.max != 0">
                  {{ "deluxe.visite.a" | translate }}
                </span>
                <span *ngIf="range.max != 0">{{ range.max }}</span>
                <span *ngIf="range.max == 0">
                  {{ "deluxe.visite.inpoi" | translate }}
                </span>
                <span class="material-symbols-outlined range__icon">
                  person
                </span>
                {{ range.costo | number : "1.2-2" }} €
              </div>
            </div>
            <div class="posti__column__wrapper">
              <div
                class="posti__row"
                *ngFor="let row of oggetto_posti_filtered"
              >
                <div class="posti__labels">
                  <div class="posti__title">
                    {{ row.label | titlecase }}
                  </div>
                  <div class="posti__hint">
                    {{ row.hint }}
                    <ng-container *ngIf="row.hint !== ''">|</ng-container>
                    {{ row.prezzo | number : "1.2-2" }} €
                  </div>
                </div>
                <div class="posti__buttons">
                  <button type="button" (click)="postiMeno(row.scelta)">
                    <span class="material-symbols-outlined"> remove </span>
                  </button>
                  <span class="posti__buttons__label">
                    {{ row.numero }}
                  </span>
                  <button type="button" (click)="postiPiu(row.scelta)">
                    <span class="material-symbols-outlined posti__button__icon">
                      add
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <hr class="small" />

            <div class="dropdown__footer">
              <div
                class="dropdown__button btn btn-red"
                (click)="attivaDropdown(2)"
              >
                {{ "pagina_acquisto.scelte.bottoni.conferma" | translate }}
                <span class="material-symbols-outlined dropdown__button__icon">
                  arrow_forward
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-1">
        <div
          class="text-gray text-14"
          [ngClass]="{ underlined: erroreLingua }"
          *ngIf="(lingueSplit && lingueSplit.length > 1) || erroreLingua"
        >
          {{ "pagina_acquisto.label_lingua" | translate }}
        </div>
        <div class="info__box__lang__wrapper" id="section__lingua">
          <div
            class="info__box__lang__chip"
            *ngFor="let lingua of lingueSplit"
            (click)="setLang(lingua)"
            [ngClass]="
              lingua === formLinguaSelezionata.value.lingua ? 'selezionato' : ''
            "
          >
            {{ lingua | lowercase | translate }}
            <img
              src="assets/img/flags/flag-{{ lingua | lowercase }}.png"
              alt="Flag {{ lingua | lowercase | translate }}"
              class="info__box__lang__chip__flag"
            />
          </div>
        </div>
      </div>

      <div
        *ngIf="promoSelezionata && promoSelezionata.codice_required === '0'"
        class="mb-1"
      >
        <app-pannello-info
          [icon]="'sell'"
          [title]="'prenotazioni.labelDescPromo'"
          [content]="promoSelezionata.promo.titolo"
          [type]="'CONFIRM'"
        ></app-pannello-info>
        <div class="mt-1">
          <app-pannello-info
            *ngIf="promoSelezionata && promoSelezionata.errore"
            [icon]="'warning'"
            [title]="
              promoSelezionata ? (promoSelezionata.errore | translate) : ''
            "
            [content]="
              promoSelezionata
                ? promoSelezionata.errore == 'promodialogo.importominimo'
                  ? '€' + promoSelezionata.promo.minimo
                  : ''
                : ''
            "
            [type]="'DELETE'"
          ></app-pannello-info>
        </div>
      </div>

      <div class="checkbox__wrapper mb-1">
        <mat-checkbox
          [checked]="mobridotta"
          (change)="mobridotta = !mobridotta"
        >
          <span class="checkbox__label">
            {{ "step1.mobridotta" | translate }}
          </span>
        </mat-checkbox>
      </div>

      <ng-container *ngIf="extrasDisponibili()">
        <div
          class="section__extra"
          id="section__extra"
          *ngIf="arrayOpzioni && arrayOpzioni.length > 0"
        >
          <h3 class="section__subheader mb-0">
            {{ "pagina_acquisto.heads.extra" | translate
            }}{{ cantina.denominazione }}
          </h3>
          <div class="mb-1 text-gray" [ngClass]="{ underlined: erroreOpzioni }">
            {{
              !parametriOpzioniTipoVisita.singole
                ? ("pagina_acquisto.heads.extra_multipli" | translate)
                : ("pagina_acquisto.heads.extra_singoli" | translate)
            }}
          </div>
          <div class="extra__wrapper">
            <div
              class="extra__item step__mode"
              *ngFor="let item of arrayOpzioni"
            >
              <div>
                <div class="extra__item__name">
                  {{ item.titolo }}
                </div>
                <div
                  class="extra__item__subname text-gray"
                  *ngIf="item.sottotitolo && item.sottotitolo !== ''"
                >
                  {{ item.sottotitolo }}
                </div>
              </div>
              <div class="extra__item__bottom">
                <hr class="small" />
                <div class="extra__item__footer">
                  <div>
                    <div class="extra__item__price">
                      <ng-container *ngIf="!isExtraFree(item)">
                        {{ item.costo | number : "1.2-2" }} €
                      </ng-container>
                      <ng-container *ngIf="isExtraFree(item)">
                        {{ "pagina_acquisto.label_incluso" | translate }}
                      </ng-container>
                    </div>
                    <div class="extra__item__person" *ngIf="isMax(item)">
                      {{ "pagina_acquisto.label_extra_max" | translate }}
                    </div>
                  </div>
                  <div class="extra__item__buttons">
                    <button
                      class="extra__item__button"
                      type="button"
                      (click)="decreaseCountExtra(item)"
                      *ngIf="item.qta > 0"
                    >
                      <span
                        class="material-symbols-outlined extra__item__button__icon"
                      >
                        remove
                      </span>
                    </button>
                    <span
                      class="extra__item__button__label"
                      *ngIf="item.qta > 0"
                    >
                      {{ item.qta }}
                    </span>
                    <button
                      class="extra__item__button"
                      type="button"
                      (click)="increaseCountExtra(item)"
                    >
                      <span
                        class="material-symbols-outlined extra__item__button__icon"
                      >
                        add
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="arrayGite && arrayGite.length > 0" />
        </div>

        <div
          class="section__extra"
          id="section__gite"
          *ngIf="arrayGite && arrayGite.length > 0"
        >
          <h3 class="section__subheader mb-0">
            {{ "pagina_acquisto.heads.gite" | translate
            }}{{ cantina.denominazione }}
          </h3>
          <div class="mb-1 text-gray" [ngClass]="{ underlined: erroreGite }">
            {{
              !parametriOpzioniGita.singole
                ? ("pagina_acquisto.heads.gite_multipli" | translate)
                : ("pagina_acquisto.heads.gite_singoli" | translate)
            }}
          </div>
          <div class="extra__wrapper">
            <div class="extra__item step__mode" *ngFor="let item of arrayGite">
              <div>
                <div class="extra__item__name">
                  {{ item.titolo }}
                </div>
                <div
                  class="extra__item__subname text-gray"
                  *ngIf="item.sottotitolo && item.sottotitolo !== ''"
                >
                  {{ item.sottotitolo }}
                </div>
              </div>
              <div class="extra__item__bottom">
                <hr class="small" />
                <div class="extra__item__footer">
                  <div>
                    <div class="extra__item__price">
                      <ng-container *ngIf="!isExtraFree(item)">
                        {{ item.costo | number : "1.2-2" }} €
                      </ng-container>
                      <ng-container *ngIf="isExtraFree(item)">
                        {{ "pagina_acquisto.label_incluso" | translate }}
                      </ng-container>
                    </div>
                    <div class="extra__item__person" *ngIf="isMax(item)">
                      {{ "pagina_acquisto.label_extra_max" | translate }}
                    </div>
                  </div>
                  <div class="extra__item__buttons">
                    <button
                      class="extra__item__button"
                      type="button"
                      (click)="decreaseCountGita(item)"
                      *ngIf="item.qta > 0"
                    >
                      <span
                        class="material-symbols-outlined extra__item__button__icon"
                      >
                        remove
                      </span>
                    </button>
                    <span
                      class="extra__item__button__label"
                      *ngIf="item.qta > 0"
                    >
                      {{ item.qta }}
                    </span>
                    <button
                      class="extra__item__button"
                      type="button"
                      (click)="increaseCountGita(item)"
                    >
                      <span
                        class="material-symbols-outlined extra__item__button__icon"
                      >
                        add
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </ng-container>

      <div class="section__intolleranze" id="section__intolleranze">
        <h3 class="section__subheader mb-0">
          {{ "pagina_acquisto.heads.richieste" | translate }}
        </h3>
        <div class="mb-1 text-gray">
          {{ "pagina_acquisto.heads.richieste_sub" | translate }}
        </div>
        <div class="extra__wrapper">
          <div
            class="extra__item__richiesta step__mode"
            *ngFor="let item of arrayRichieste"
          >
            <div class="extra__item__title__image">
              <img [src]="item.icon" alt="" class="extra__item__image" />
              <div>
                <div
                  class="extra__item__name"
                  [innerHTML]="item.label | translate"
                ></div>
                <div
                  class="extra__item__subname text-gray"
                  *ngIf="item.sottotitolo && item.sottotitolo !== ''"
                >
                  {{ item.sottotitolo }}
                </div>
              </div>
            </div>
            <div class="extra__item__right">
              <div class="extra__item__footer">
                <div class="extra__item__buttons">
                  <button
                    class="extra__item__button"
                    type="button"
                    (click)="decreaseCountExtra(item)"
                    *ngIf="item.qta > 0"
                  >
                    <span
                      class="material-symbols-outlined extra__item__button__icon"
                    >
                      remove
                    </span>
                  </button>
                  <span class="extra__item__button__label" *ngIf="item.qta > 0">
                    {{ item.qta }}
                  </span>
                  <button
                    class="extra__item__button"
                    type="button"
                    (click)="increaseCountExtra(item)"
                  >
                    <span
                      class="material-symbols-outlined extra__item__button__icon"
                    >
                      add
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="continua" *ngIf="getPostiDisponibili() > 0">
        <hr class="mb-1" />
        <div class="head mb-1 mt-2">
          {{ "base.riepilogo" | translate }}
        </div>
        <div class="riepilogo">
          <div class="riepilogo__line mb-1" *ngIf="visitaHasPernottamento()">
            <label class="riepilogo__label">
              {{ "prenotazioni.datapernottamento" | translate }}
            </label>
            <div class="riepilogo__total bold">
              {{ dataSenzaOra }}
              <br />
              <small
                class="cambia__data"
                (click)="goToCalendario()"
                *ngIf="tutteledate && tutteledate.length > 1"
              >
                <u>
                  {{ "prenotazioni.cambiadata" | translate }}
                </u>
              </small>
            </div>
          </div>

          <div class="riepilogo__line" *ngIf="visitaHasPernottamento()">
            <label class="riepilogo__label">
              {{ "prenotazioni.checkin_pernottamento" | translate }}
            </label>
            <div class="riepilogo__total bold">
              {{
                visitaselezionata.check_in_visita
                  ? visitaselezionata.check_in_visita
                  : ("prenotazioni.dadefinire" | translate)
              }}
            </div>
          </div>

          <div class="riepilogo__line mb-1" *ngIf="visitaHasPernottamento()">
            <label class="riepilogo__label">
              {{ "prenotazioni.datavisitapernottamento" | translate }}
            </label>
            <div class="riepilogo__total bold">
              {{
                dataSvolgimento && dataSvolgimento["translation"]
                  ? (dataSvolgimento["data"] | translate)
                  : dataSvolgimento["data"]
              }}
              <br *ngIf="!dataSvolgimento['translation']" />
              <small
                *ngIf="!dataSvolgimento['translation']"
                class="stessa__data"
              >
                {{ "prenotazioni.orariocomunicato" | translate }}
              </small>
            </div>
          </div>

          <div class="riepilogo__line">
            <div class="riepilogo__label">
              {{ "base.lingua" | translate }}
            </div>
            <div class="riepilogo__value">
              <div *ngIf="formLinguaSelezionata.value.lingua">
                <span class="d-flex align-center">
                  {{ linguaScelta | translate }}
                  <img
                    src="assets/img/flags/flag-{{
                      linguaScelta | lowercase
                    }}.png"
                    alt="Flag {{ lingua | lowercase | translate }}"
                    class="info__box__lang__chip__flag"
                  />
                </span>
              </div>
              <div
                *ngIf="!formLinguaSelezionata.value.lingua"
                (click)="selezionaLingua()"
              >
                {{ "step1.selezionalingua" | translate }}
              </div>
            </div>
          </div>
          <div class="riepilogo__line">
            <div class="riepilogo__label">
              {{ "step1.totale" | translate }}
            </div>
            <div
              class="riepilogo__value"
              [ngClass]="{ barrato: promoSelezionata }"
            >
              € {{ totaleVisualizzato | number : "1.2-2" }}
            </div>
          </div>
          <div class="riepilogo__line" *ngIf="promoSelezionata">
            <div class="riepilogo__label">
              {{ "prenotazioni.labelTotaleScontato" | translate }}
            </div>
            <div class="riepilogo__value">
              € {{ totalescontato | number : "1.2-2" }}
            </div>
          </div>
        </div>
        <div class="flex-actions mt-2">
          <button class="btn btn-red" (click)="riscattaCodice()">
            {{ "step1.codpormo" | translate | uppercase }}
            <span class="material-symbols-outlined icon"> card_giftcard </span>
          </button>
          <button class="btn buttonContinua" (click)="continua()">
            {{ "step1.preenotaora" | translate | uppercase }}
            <span class="material-symbols-outlined icon"> shopping_bag </span>
          </button>
        </div>
      </div>

      <div *ngIf="getPostiDisponibili() <= 0" class="completo">
        <h3>
          <b>
            {{ "step1.postifiniti_titolo" | translate }}
          </b>
        </h3>
        {{ "step1.postifiniti_testo" | translate }}
      </div>
    </div>
    <div *ngIf="!ricercaFatta">
      <app-step1-loading></app-step1-loading>
    </div>
    <div *ngIf="!visitaselezionata && ricercaFatta" class="nores">
      <div class="nores-title">
        {{ "base.nessuna_visita_title" | translate }}
      </div>
      <div
        class="nores-subtitle"
        [innerHTML]="
          'base.nessuna_visita_subtitle' | translate : { value: denominazione }
        "
      ></div>
    </div>
  </div>
  <div *ngIf="checkAbilitato && !abilitato" class="padd-1">
    <div class="nores-text cantina-name">
      <strong>
        {{ nonabilitatoMsg | translate }}
      </strong>
    </div>
    <img src="../../assets/img/ko.png" alt="" class="w-100" />
    <div class="nores-text cantina-name">
      <strong>
        {{ nonabilitatoMsg | translate }}
      </strong>
    </div>
  </div>
</div>
